import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const agendaSelectDate = payload => ({
  type: types.AGENDA_SELECT_DATE,
  payload,
});
